import { useState, useReducer } from "react";
import api from "@helpers/api";

import editEventModalReducer, {
  initialState,
  eventTypes
} from "./editEventModalReducer";
import validateFields from "@helpers/formValidator";
import { formatSSN } from "@helpers/utils";

const useEditEventModal = props => {
  const { open, client, toggle, updateEvents } = props;

  const [state, dispatch] = useReducer(editEventModalReducer, {
    ...initialState
  });

  const handleDateChange = (date, type) => {
    if (date) {
      dispatch({
        type: type === "start" ? "setStartTime" : "setEndTime",
        payload: date
      });
    }
  };

  // const [newEvent, setNewEvent] = useState(event?.Event || "");
  const canSubmitForm = !!(
    state.title &&
    state.startTime &&
    state.endTime &&
    state.description
  );

  const isValidInput = (fieldName, value) => {
    return (
      value.length > 0 && (!state.inputErrors || !state?.inputErrors[fieldName])
    );
  };

  const handleInputChange = async e => {
    e.preventDefault();
    const key = e.target.name;
    let value = e.target.value;

    dispatch({
      type: "handleInput",
      field: key,
      payload: value
    });

    const formData = {
      ...state,
      [key]: value
    };

    const fieldsToValidate = { ...formData };

    let inputErrors = validateFields(fieldsToValidate);

    return dispatch({
      type: "handleInputErrors",
      payload: inputErrors || {}
    });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    dispatch({
      type: "handleServerError",
      payload: null
    });

    let { action, type } = state;

    const formData = {
      ...state,
      clientId: client.id,
      startTime: state.startTime.format("YYYY-MM-DD HH:mm:ss"),
      endTime: state.endTime.format("YYYY-MM-DD HH:mm:ss")
    };

    dispatch({
      type: "fetching",
      payload: true
    });

    try {
      // will send a POST request to /customer/add or /customer/edit depending on the action
      const event = await api(`/client/events/${action}`, formData);
      if (!event)
        return dispatch({
          type: "handleServerError",
          payload: "Something went wrong. Please contact support."
        });
        
      updateEvents(event);
      toggle();
    } catch (err) {
      console.log(err, "err");
      // errorHandler.serverError(err);
      const msg = err?.response?.data?.msg;

      if (msg) {
        return dispatch({
          type: "handleServerError",
          payload: msg
        });
      }

      return dispatch({
        type: "handleServerError",
        payload: `Error: ${err?.msg || "Unknown error."}`
      });
    }
  };

  return {
    open,
    toggle,
    eventTypes,
    state,
    isValidInput,
    canSubmitForm,
    handleInputChange,
    handleDateChange,
    handleSubmit
  };
};

export default useEditEventModal;
